import React, { Component } from 'react';

import { APIHandler,ContactCard,DataHandler  } from 'C4';

export default class ContactView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      contacts: [],
      appId: 0,
    };
  }

  componentDidMount() {
    this.loadContacts();
  }
  
  loadContacts() {
    const params = new URLSearchParams(window.location.search);
    const id = params.get('app_id');

    if (id) {
      APIHandler.getContacts(id).then((res) => {
        this.setState({ contacts: res.response, id });
      });
    } else {
      DataHandler.matchAppId().then((appId) => {
        APIHandler.getContacts(appId).then((res) => {
          this.setState({ contacts: res.response, appId });
        });
      });
    }
  }

  render() {
    const { contacts, appId } = this.state;
    let prevArea = null; 
    const params = new URLSearchParams(window.location.search);

    return (
      <div className="contentContainer contact">
        <div className="contactView">
          {contacts && contacts.map((contact, index) => (
            <React.Fragment key={index}>
              {contact.area !== prevArea && (
                <div className="contacts__region-title">
                  {contact.area}
                </div>
              )}
              {contact.name !== '' && contact.image !== '' && (                
                <div className="contactView__Card">
                  <div className="contactView__Content__Card">
                    <ContactCard
                      name={contact.name}
                      title={contact.title}
                      address={contact.address}
                      avatar={contact.avatar}
                      options={contact.options}
                      mail={contact}
                      appId={appId}
                      imageUrl={contact.image}
                      telephone={contact.phone}
                      website={contact.website}
                      country={contact.country}
                    />
                  </div>
                </div>
              )}
              {/* Update prevArea with the current contact's area */}
              <div className="hidden">{prevArea = contact.area}</div>
            </React.Fragment>
          ))}
        </div>
        {params.get('mobile') && (
          <style>
            {
              '\
        .cookieConsent { display: none !important; } nav.mini { display: none !important; } .contentContainer { margin-top: 2rem !important; }'
            }
          </style>
        )}
      </div>
    );
  }
  
}